import { ulid } from "ulid"
import { createTriggerUtils, ITrigger, ITriggerWebConfig, ITriggerJavaData } from "@droid/project-v2-interface"
import { a11yTriggerNamespace } from "../a11y-namespace"
import { UI } from "./UI"
import { ManifestPermission } from "@droid/android"
import { RhinoInjectNames } from "@app/static"
import { NodeSelectorChain } from "./selector-chain"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, '[ITriggerNodeTrigger]')
fileLog.pause = true
fileLog.childrenPaused = true

export const triggerNodeTriggerType = `${a11yTriggerNamespace}node-trigger`
const type = triggerNodeTriggerType
fileLog.log('[ITriggerNodeTrigger] type:', type)

/**
 * NodeTrigger 的 Java 端数据结构
 */
export interface ITriggerNodeTriggerJavaData extends ITriggerJavaData {
    /** 包名 */
    pn: string
    /** Activity 名 */
    an: string
    /** 页面类名 (可选) */
    cn?: string
    /** Selector链式操作配置 */
    selectorChain: NodeSelectorChain
}

/**
 * NodeTrigger 的完整数据结构
 */
export interface ITriggerNodeTriggerWebConfig extends ITriggerWebConfig {
    // Node Trigger 特有的 Web 配置
}

export interface ITriggerNodeTriggerData extends ITrigger<ITriggerNodeTriggerJavaData, ITriggerNodeTriggerWebConfig> {
    javaData: ITriggerNodeTriggerJavaData
}

/**
 * 创建默认的 NodeTrigger 数据
 */
function createDefaultData(): ITriggerNodeTriggerData {
    fileLog.log('[ITriggerNodeTrigger.createDefaultData] 开始创建默认数据')

    const ulidValue = ulid()
    fileLog.log('[ITriggerNodeTrigger.createDefaultData] 生成ulid:', ulidValue)

    const permissions = [
        {
            name: '辅助功能权限',
            value: ManifestPermission.BIND_ACCESSIBILITY_SERVICE,
            reason: '需要辅助功能来监听应用切换和查找节点'
        }
    ]
    fileLog.log('[ITriggerNodeTrigger.createDefaultData] 权限数量:', permissions.length)

    const injects: ([typeof RhinoInjectNames.a11yModel, string])[] = [
        [RhinoInjectNames.a11yModel, 'a11yModel']
    ]
    fileLog.log('[ITriggerNodeTrigger.createDefaultData] 注入配置数量:', injects.length)

    const defaultData: ITriggerNodeTriggerData = {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        type,
        name: 'triggerNodeTrigger',
        permissions,
        injects,
        javaData: {
            pn: '',
            an: '',
            cn: '',
            selectorChain: {
                operations: []
            }
        },
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
    fileLog.log('[ITriggerNodeTrigger.createDefaultData] defaultData:', JSON.stringify(defaultData))
    return defaultData
}

/**
 * 初始化函数
 */
function init() {
    fileLog.log('[ITriggerNodeTrigger.init] 初始化')
}

/**
 * NodeTrigger 工具对象
 */
export const triggerNodeTriggerUtils = createTriggerUtils<ITriggerNodeTriggerData>(type, init, createDefaultData, UI)
